import React, { useState } from 'react'
import "./blogs.css"
import Navbar from '../Navbar/Navbar'
import Footer from '../Footer/Footer'
import pdfImg from '../../Images/Blogs/pdflogo.png';
import pdfFile from '../../../Files/datacontracts.pdf'
import dcDoc from '../../../Files/dcdoc.pdf';

const Blogs = () => {

  const [show, setShow] = useState(false);
  const handleToggle = () => {
    setShow(prev => !prev)
  }

  return (
    <>
     <Navbar />
     {show && <div className="db-pdf-viewer">
      <div className="db-pdf-head" onClick={handleToggle}>X</div>
       <embed
          src={dcDoc}
          type="application/pdf"
          className='db-pdf-sect'
       />
     </div>}
     <div className="db-blogs-articles-sect">
        <div className="db-blogs-articles-wrap">
          <div className='db-blogs-articles-head'>Blogs and Articles</div>
            <div className="db-blogs-sect">

              <div className="db-blog-wrap" >
                <img src={pdfImg} alt="pdf" />
                <div className="db-blog-head">Data Contracts</div>
                <button style={{padding: "0.4rem 0.8rem", cursor:'pointer'}} onClick={() => handleToggle( )}>Open PDF</button>
                <a href={pdfFile} download style={{paddingLeft : "0.8rem"}}>
                  <button className='db-blog-download-btn' style={{padding: "0.4rem 0.8rem", cursor:'pointer'}}>Download PDF</button>
                </a>
              </div>

            </div>
        </div>
     </div>
     <Footer />
    </>
  )
}

export default Blogs
